import { commonAPI } from '@redux/api/common.api'
import { URLS } from '@constants'
import { Variable } from '@mobileTypes'

type GETMobileVariablesParams = {
  searchPattern?: string
  sort?: string
}

export const mobileVariableApi = commonAPI.injectEndpoints({
  endpoints: build => ({
    fetchAllMobileGlobalVariables: build.query<Variable[], GETMobileVariablesParams | void>({
      query: params => ({
        url: URLS.MOBILE_CFG + '/variable/list',
        params: {
          searchPattern: params?.searchPattern,
          sort: params?.sort,
        },
      }),
      providesTags: ['AllMobileGlobalVariables'],
    }),

    fetchMobileGlobalVariableByInternalId: build.query<Variable, string>({
      query: internalId => ({
        url: URLS.MOBILE_CFG + `/variable/internalId/${internalId}`,
      }),
      providesTags: ['SingleMobileGlobalVariable'],
    }),

    fetchMobileGlobalVariableById: build.query<Variable, string>({
      query: id => ({
        url: URLS.MOBILE_CFG + `/variable/id/${id}`,
      }),
      providesTags: ['SingleMobileGlobalVariable'],
    }),

    createMobileGlobalVariable: build.mutation<Variable, Omit<Variable, 'id'>>({
      query: item => ({
        url: URLS.MOBILE_CFG + '/variable',
        method: 'POST',
        body: item,
      }),
      invalidatesTags: ['AllMobileGlobalVariables'],
    }),

    updateMobileGlobalVariable: build.mutation<Variable, Variable>({
      query: item => ({
        url: URLS.MOBILE_CFG + '/variable',
        method: 'POST',
        body: item,
      }),
      invalidatesTags: ['AllMobileGlobalVariables', 'SingleMobileGlobalVariable'],
    }),

    deleteMobileGlobalVariable: build.mutation<void, string>({
      query: id => ({
        url: URLS.MOBILE_CFG + `/variable/id/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AllMobileGlobalVariables'],
    }),

    copyMobileGlobalVariable: build.mutation<Variable, { id: string; internalId: string }>({
      query: body => ({
        url: URLS.MOBILE_CFG + '/variable/copy',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['AllMobileGlobalVariables'],
    }),
  }),
})

export const {
  useFetchAllMobileGlobalVariablesQuery,
  useFetchMobileGlobalVariableByInternalIdQuery,
  useFetchMobileGlobalVariableByIdQuery,
  useCreateMobileGlobalVariableMutation,
  useUpdateMobileGlobalVariableMutation,
  useDeleteMobileGlobalVariableMutation,
  useCopyMobileGlobalVariableMutation,
} = mobileVariableApi

